module.exports = __webpack_public_path__ + "static/media/newcastle_bs.4bcb31ae.png";